<template>
  <div class="message-image message-component" :style="imageStyle">
    <el-image
      class="img-box"
      :src="data.url"
      :preview-src-list="[data.url]"
      @load="loadImage"
      :fit="'contain'"
    >
    </el-image>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      show: false,
      imageStyle: {},
      maxWidth: 250,
    };
  },
  watch: {
    data: {
      handler(newValue) {
        this.getImageStyle();
      },
      immediate: true,
    },
    chatMode: {
      handler(newValue) {
        // 模式切换：需重新计算图片宽高（否则有bug：图片宽高不正确）
        this.getImageStyle();
      },
      immediate: true,
    },
  },
  mounted() {},
  computed: {
    ...mapState("newChat", ["chatMode"]),
  },
  methods: {
    // 图片加载中：宽高占位
    getImageStyle() {
      if (
        this.imageStyle?.width &&
        Number(this.imageStyle?.width.replace("px", "")) < this.maxWidth
      ) {
        return;
      }
      if (this.data.width && this.data.height) {
        // 获取图片比例
        const widthRatio = this.data.width / this.data.height;
        const width = Math.min(this.maxWidth, this.data.width);
        // 取整
        const height = Math.floor(width / widthRatio);
        if (this.imageStyle.width !== width + "px") {
          this.imageStyle = {
            width: width + "px",
            height: height + "px",
          };
        }
      }
    },
    loadImage(e) {
      // 图片加载完成 由于ios返回的图片有的宽高反了，需要根据图片的实际宽高和当前已设置的高度重新设置宽高
      const height = e.target.naturalHeight;
      const width = e.target.naturalWidth;
      const ratio = width / height;
      const boxHeight = e.target.height;
      this.imageStyle = {
        width: boxHeight * ratio + "px",
        height: boxHeight + "px",
      };

      this.$emit("loadedImage");
    },
  },
};
</script>
<style lang="scss" scoped>
.message-image {
  max-width: 250px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
  .img-box {
    width: 100%;
    height: 100%;
  }
  .message-img {
    max-width: min(calc(100vw - 180px), 300px);
    max-height: min(calc(100vw - 180px), 300px);
  }
  .progress {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0 20px;
    left: 0;
    top: 0;
    background: rgba(#000000, 0.5);
    display: flex;
    align-items: center;
    progress {
      color: #006eff;
      appearance: none;
      border-radius: 0.25rem;
      background: rgba(#ffffff, 1);
      width: 100%;
      height: 0.5rem;
      &::-webkit-progress-value {
        background-color: #006eff;
        border-radius: 0.25rem;
      }
      &::-webkit-progress-bar {
        border-radius: 0.25rem;
        background: rgba(#ffffff, 1);
      }
      &::-moz-progress-bar {
        color: #006eff;
        background: #006eff;
        border-radius: 0.25rem;
      }
    }
  }
}
.dialog {
  position: fixed;
  z-index: 1000000;
  width: 100vw;
  height: 100vh;
  background: rgba(#000000, 0.3);
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  header {
    display: flex;
    justify-content: flex-end;
    background: rgba(0, 0, 0, 0.49);
    width: 100%;
    box-sizing: border-box;
    padding: 10px 10px;
  }
  &-box {
    display: flex;
    flex: 1;
    max-height: 100%;
    padding: 6rem;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
  }
}
.dialog-box-h5 {
  width: 100%;
  height: 100%;
  background: #000000;
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  &-footer {
    position: fixed;
    bottom: 10px;
    display: flex;
    width: 90vw;
    justify-content: space-between;
    p {
      width: 3.88rem;
      height: 3.88rem;
    }
    img {
      width: 100%;
    }
    i {
      padding: 20px;
    }
  }
}
</style>
